// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.stores-layout[data-v-3967bbae] {\n  min-height: 100vh;\n  max-width: 100%;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  left: 50% !important;\n  right: 50% !important;\n  background: #f5f5f5;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
